const getDate = (createdAt) => createdAt && new Date(createdAt).getMonth();

export default getDate;
